import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PricePlanBundleAPI(): BringozApi {
  return {
    base: `/priceplansBundle`,
    infiniteScroll: {
      address: `/priceplansBundle`,
      cmd: 'GET'
    },
    actions: {
      accountPricePlans: {
        address: 'account/{accountId}',
        cmd: 'GET'
      },
      getDefaultProgramTypeByServiceType: {
        address: 'service/{serviceType}/account/{accountId}',
        cmd: 'GET'
      },
      updateAccountBundle: {
        address: 'account/{accountId}',
        cmd: 'POST'
      },
      getSitePrograms: {
        address: 'programs',
        cmd: 'GET'
      },
      getSiteServicesProgramType: {
        address: 'programs/service',
        cmd: 'GET'
      },
      setSiteServiceProgramType: {
        address: 'programs/service/{serviceType}',
        cmd: 'PUT'
      },
      createProgram: {
        address: 'programs',
        cmd: 'PUT'
      },
      updateProgram: {
        address: 'programs/{id}',
        cmd: 'POST'
      },
      getSiteAdditions: {
        address: 'programs/additions',
        cmd: 'GET'
      },
      createSiteAddition: {
        address: 'programs/additions',
        cmd: 'PUT'
      },
      updateSiteAddition: {
        address: 'programs/additions/{id}',
        cmd: 'POST'
      },
      deleteSiteAddition: {
        address: 'programs/additions/{id}',
        cmd: 'DELETE'
      },
      getBundleById: {
        address: '{bundleId}',
        cmd: 'GET'
      },
      getAllBundles: {
        address: 'all',
        cmd: 'GET'
      },
      editBundle: {
        address: '',
        cmd: 'GET'
      },
      duplicateBundle: {
        address: '{bundleId}/duplicate',
        cmd: 'PUT'
      },
      setAsDefault: {
        address: '{bundleId}/default',
        cmd: 'POST'
      },
      getAllChilds: {
        address: '{bundleId}/children',
        cmd: 'GET'
      },
      getRootBundles: {
        address: 'root',
        cmd: 'GET'
      },
      createBundle: {
        address: '',
        cmd: 'PUT'
      },
      getPackageItems: {
        address: 'items',
        cmd: 'GET'
      },
      createPackageItem: {
        address: 'items',
        cmd: 'PUT'
      },
      updatePackageItem: {
        address: 'items/{itemId}',
        cmd: 'POST'
      },
      setDefaultPackageItem: {
        address: 'items/setDefault/{itemId}',
        cmd: 'POST'
      },
      getHierarchy: {
        address: 'hierarchy',
        cmd: 'GET',
        updateable: false
      },
      updateAccounts: {
        address: '{pricePlanBundleId}/updateAccounts',
        cmd: 'POST',
        updateable: false
      },
      getLineSplitConfiguration: {
        address: 'programs/service/lineSplitConfiguration',
        cmd: 'GET',
        updateable: false
      },
      updateLineSplitConfiguration: {
        address: 'programs/service/lineSplitConfiguration',
        cmd: 'PUT',
        updateable: false
      },
      getServiceValidations: {
        address: 'programs/serviceValidations',
        cmd: 'GET',
        updateable: false
      },
      createServiceValidations: {
        address: 'programs/serviceValidations',
        cmd: 'PUT',
        updateable: false
      },
      updateServiceValidations: {
        address: 'programs/serviceValidations/{id}',
        cmd: 'POST',
        updateable: false
      },
      exportPrograms: {
        address: '{id}/export',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .factory('PricePlanBundleAPI', PricePlanBundleAPI);
